import { useMemo } from "react";
import { useRecoilState } from "recoil";
import { ModalDataState } from "../../../common/recoil/modalAtoms";
import { isUserGainedItem } from "../../../common/types/typeGuard";
import ModalTemplate from "../../../templates/ModalTemplate";
import ImageComponent from "../../shared/ImageComponent";
import { useModal } from "../hooks/modalHooks";
import Default from "./infoItemContents/Default";
import styles from "./ModalContents.module.scss";

const InfoItem: React.FC = () => {
  const [isVisible, setIsVisible] = useModal("infoItem");
  const [modalData, setModalData] = useRecoilState(ModalDataState);

  const renderContent = useMemo(() => {
    // modalDataがunionなので型判定
    if (!isUserGainedItem(modalData)) return null;

    const { type } = modalData;

    if (type === "default") return <Default userGainedItem={modalData} />;
  }, [modalData]);

  return (
    <>
      {isVisible && (
        <ModalTemplate
          bgCloseFunction={() => {
            setModalData(null);
            setIsVisible(false);
          }}
        >
          <div className={styles.modalBody}>{renderContent}</div>
          <div className={styles.btnModalClose}>
            <button
              type="button"
              onClick={() => {
                setModalData(null);
                setIsVisible(false);
              }}
            >
              <ImageComponent
                url="/images/btn/default/btn_close01"
                alt="謎画像"
                width={36}
                height={36}
                objectFit="cover"
                withBlur={false}
              />
            </button>
          </div>
        </ModalTemplate>
      )}
    </>
  );
};

export default InfoItem;
